export default class CacheableDataObject {
	constructor(data) {
		this.beforeConstruct(data);
		this.update(data);
		this.afterConstruct(data);
	}

	beforeConstruct() {
	}

	afterConstruct() {
	}

	beforeUpdate() {
	}

	afterUpdate() {
	}

	static create(data) {
		return this.newInstance(data);
	}

	update(data) {
		if(this.beforeUpdate(data) === false) {
			return this;
		}
		for(let i in data) {
			if(!data.hasOwnProperty(i)) {
				continue;
			}
			if(this.dataLocationParsers[i]) {
				this.dataLocationParsers[i].call(this, this, data, i);
			}
			else {
				this[i] = data[i];
			}
		}
		this.afterUpdate(data);
		return this;
	}

	serialize() {
		const data = {};
		for(const field of this.serializeFields) {
			data[field] = this[field];
		}
		return data;
	}

	static retrieveById(id) {
		//TODO: Update this to be able to use dynamic id fields
		return this.retrieve({ id: id });
	}

	static retrieve(data, idToSave) {
		let className = this.name;
		let id = null;

		if(data === null || data === undefined) {
			// Not sure if this is right, but this will fix issues where an "Invalid" object instance is passed in
			return data;
		}

		if(idToSave) {
			id = idToSave;
		}
		else {
			if(!data) {
				console.log(data);
			}
			id = data.id;

		}
		if(!CacheableDataObject.cache[className]) {
			CacheableDataObject.cache[className] = {};
		}
		if(CacheableDataObject.cache[className][id]) {
			if(CacheableDataObject.cache[className][id] === data) {
				return data;
			}
			return CacheableDataObject.cache[className][id].update(data);
		}
		else {
			let newInstance = this.create(data);
			if(id) {
				CacheableDataObject.cache[className][id] = newInstance;
			}
			return newInstance;
		}
	}

	static hasCached(id) {
		let className = this.name;
		return CacheableDataObject.cache[className] && !!CacheableDataObject.cache[className][id];
	}

	static newInstance(data) {
		return new this(data);
	}
}

CacheableDataObject.cache = {};
CacheableDataObject.prototype.dataLocationParsers = {};
CacheableDataObject.prototype.serializeFields = [];